import { isAndroid, isIOS, isMobile } from 'react-device-detect'

const METAPRO_WALLET_URL = `${import.meta.env.VITE_METAPRO_WALLET_URL}/download`
const APP_STORE_URL = import.meta.env.VITE_METAPRO_WALLET_APP_STORE_URL as string
const GOOGLE_PLAY_URL = import.meta.env.VITE_METAPRO_WALLET_GOOGLE_PLAY_URL as string
const now = new Date().valueOf()

export const redirectToWalletStore = () => {
  if ((isAndroid || isIOS) && isMobile) {
    window.location.replace(isIOS ? APP_STORE_URL : GOOGLE_PLAY_URL)
  } else {
    window.open(METAPRO_WALLET_URL, '_blank')
  }
}

export const handleMobileAppRedirection = (deepLink?: string) => {
  if (isAndroid || isIOS) {
    window.location.replace(deepLink || 'mone://')
    setTimeout(() => {
      if (new Date().valueOf() - now > 900) return
      window.location.replace(isIOS ? APP_STORE_URL : GOOGLE_PLAY_URL)
    }, 1000)
  } else {
    window.open(`${METAPRO_WALLET_URL}/download`, '_blank')
  }
}
